const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlazLogosmallnew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "24px",
    viewBox: "0 0 40 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(63.137257%,63.137257%,63.137257%)",
      fillOpacity: 1
    },
    d: "M 0 0.597656 L 20.847656 0.597656 L 20.21875 7.433594 L 0.40625 7.433594 Z M 0 0.597656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(85.09804%,85.09804%,85.09804%)",
      fillOpacity: 1
    },
    d: "M 3.976562 8.882812 L 20.078125 8.882812 L 19.453125 15.71875 L 4.371094 15.402344 Z M 3.976562 8.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.914062 17.164062 L 19.40625 17.164062 L 18.726562 24 L 8.300781 23.757812 Z M 7.914062 17.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.980469 24 L 21.851562 3.164062 C 21.941406 2.398438 22.019531 1.792969 22.085938 1.339844 C 22.175781 0.890625 22.351562 0.558594 22.621094 0.351562 C 22.886719 0.140625 23.3125 0.0390625 23.890625 0.0390625 L 39.222656 0.0390625 L 38.824219 4.363281 L 27.097656 4.363281 L 26.628906 9.570312 L 37.285156 9.570312 L 36.917969 13.894531 L 26.226562 13.894531 L 25.328125 24 Z M 19.980469 24 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlazLogosmallnew);
export default __webpack_public_path__ + "static/media/flaz_logosmallnew.7e2fdb5950785a3fce93157424b9749e.svg";
export { ForwardRef as ReactComponent };